module.exports = __webpack_public_path__ + "img/teaser_training6.a4d334b0.jpg";